<template>
	<div class="base_box">
		<baseCrumbs :list="crumbs"></baseCrumbs>
		<div class="base_form base_form_padding base_page_height">
			<!-- 订单信息 -->
			<div class="   order-info" style="border-bottom: 1px solid #f5f7fa;padding-bottom: 10px;margin-bottom: 30px;">
				<div class="order_boxwe">
					<div class="order_info_tit">采购信息</div>
					<div class="info_itembox" style="align-items: flex-start;">
						<div class="item" style="width: 100%;">计划交货日期：<el-date-picker value-format="yyyy-MM-dd"
								format="yyyy-MM-dd" size="small" v-model="orderInfo.plan_delivery_time" type="date"
								placeholder="选择日期">
							</el-date-picker>
							<el-button style="margin-left: 20px;" class="  base_but_style  " type="info" plain
								@click="goods.show = true">添加商品</el-button>
						</div>
					</div>
				</div>
			</div>
			<!-- 订单商品 -->
			<div style="overflow-y: scroll;height: calc(100% - 120px);">
				<div class="   order-info" >

					<baseTable :list="orderInfo.detail" :tableList="tableForm">
						<template #goods_img="scope">
							<img v-if="scope.row.goods.images.length>0" :src="scope.row.goods.images[0].file.url"
								style="width: 50px;height: 50px;" alt="" />
						</template>
						<template #goods_name="scope">
							{{scope.row.goods.goods_name || ''}}
						</template>
						<template #goods_props="scope">
							<span v-for="(item,index) in scope.row.goods_props" :key="index">
								{{item.value.name}}
							</span>
						</template>
						<template #procurement_user_id="scope">
							<el-select @change="(e)=>changeInput(scope,'procurement_user_id')" size="small" v-model="scope.row.procurement_user_id" placeholder="请选择采购员">
								<el-option v-for="item in procurementUser" :key="item.id" :label="item.label"
									:value="item.id">
								</el-option>
							</el-select>
						</template>
						<template #supplier_id="scope">
							<el-select @change="(e)=>changeInput(scope,'supplier_id')" size="small" v-model="scope.row.supplier_id" placeholder="请选择供货商">
								<el-option v-for="item in supplierUser" :key="item.id" :label="item.label"
									:value="item.id">
								</el-option>
							</el-select>
						</template>
						<template #plan_number="scope">
							<el-input @blur="(e)=>changeInput(scope,'plan_number')" v-model="scope.row.plan_number" style="width: 160px;" placeholder="请输入计划采购量"
								size="small"></el-input>
						</template>
						<template #remarks="scope">
							<el-input @blur="(e)=>changeInput(scope,'remarks')" v-model="scope.row.remarks" style="width: 160px;" placeholder="请输入采购备注"
								size="small"></el-input>
						</template>
						<!-- 操作 -->
						<template #action="scope">
							<div @click="delFun(scope?.row?.$index)" class="but_danger">删除</div>
						</template>
					</baseTable>
				</div>
			</div>
		</div>
		<div class="base_fixed_bottom">
			<el-button class="base_but_style base_save_but" type="primary" @click="saveFun()">保存</el-button>
		</div>
		<baseModal width="800px" title="选择商品" @sureFun="goodsFun" @cancalFun="()=>{goods.show = false}"
			:dialogVisible="goods.show">
			<template #content="scope">
				<baseSearch style="padding-top: 0;" :list="searchFrom" @search="searchFun">
				</baseSearch>
				<div style="margin-right: 10px;">
					<baseTable style="margin-bottom: -20px;" :total="goods.total" :page="goods.post.page" :pagesize="goods.post.limit"
						:list="goods.table" :tableList="goods.tableForm" @changePage="changePage" :selection="true"
						@tableSelectionChange="tableSelectionChange">
						<template #goods_img="scope">
							<img v-if="scope.row.goods.images.length>0" :src="scope.row.goods.images[0].file.url"
								style="width: 50px;height: 50px;" alt="" />
						</template>
						<template #goods_name="scope">
							{{scope.row.goods.goods_name || ''}}
						</template>
						<template #goods_props="scope">
							<span v-for="(item,index) in scope.row.goods_props" :key="index">
								{{item.value.name}}
							</span>
						</template>
					</baseTable>
				</div>
			</template>
		</baseModal>
	</div>
</template>
<script>
	import {
		eltips
	} from "@/util/util.js";
	import baseModal from "@/components/common/baseModal.vue";
	import baseTable from "@/components/common/baseTable.vue";
	import baseSearch from "@/components/common/baseSearch.vue";
	export default {
		components: {
			baseTable,
			baseModal,
			baseSearch
		},
		data() {
			return {
				crumbs: [],
				active: 1,
				orderInfo: {
					plan_delivery_time: '',
					detail: []
				},
				tableForm: [{
						label: "商品图片",
						prop: "goods_img",
						width: 90
					},
					{
						label: "商品名称",
						prop: "goods_name",
						align:'left'
					},
					{
						label: "商品规格",
						prop: "goods_props",
						align:'left'
					},
					{
						label: "现有库存",
						prop: "stock_num",
						width:100
					},
					{
						label: "计划采购量",
						prop: "plan_number"
					},
					{
						label: "采购员",
						prop: "procurement_user_id"
					},
					{
						label: "供货商",
						prop: "supplier_id"
					},
					{
						label: "备注",
						prop: "remarks"
					},
					{
						label: "操作",
						prop: "action",
						width:80
					},
				],
				procurementUser: [],
				supplierUser: [],
				goods: {
					show: false,
					list: [],
					index: '',
					total: 0,
					table: [],
					post: {
						page: 1,
						limit: 5
					},
					tableForm: [{
							label: "商品图片",
							prop: "goods_img",
							width: 90
						},
						{
							label: "商品名称",
							prop: "goods_name",
							align:'left'
						},
						{
							label: "商品规格",
							prop: "goods_props",
							align:'left'
						},
						{
							label: "商品单位",
							prop: "unit_name",
							width: 90
						},
					]
				},
				searchFrom: [{
						type: "input",
						Field: "keyword",
						label: "商品名称",
						style: {
							width: "130px",
						},
						placeholder: "请输入商品名称",
					},
					{
						type: "cascader",
						Field: "category_id",
						label: "商品分类",
						style: {
							width: "140px",
						},
						options: [],
						placeholder: "请选择",
						props: {
							value: "category_id",
							label: "name",
							children: "children",
						},
					}
				],
			};
		},
		mounted() {},
		created() {
			let _this = this
			_this.crumbs = _this.$route.query.crumbs;
			_this.axios.get("/api/weishop/admin/plugin/erp/procurement-user/index", {
					limit: 10000,
					status:1
				})
				.then((res) => {
					if (res.code == 200) {
						if (res.data.data.length > 0) {
							res.data.data.map(red => {
								red.label = red.name + '/' + red.mobile
								return red
							})
						}
						this.procurementUser = res.data.data;
					} else {
						eltips(res.msg, "error");
					}
				});
			_this.axios.get("/api/weishop/admin/plugin/erp/supplier/index", {
					limit: 10000
				})
				.then((res) => {
					if (res.code == 200) {
						if (res.data.data.length > 0) {
							res.data.data.map(red => {
								red.label = red.name + '/' + red.mobile
								return red
							})
						}
						this.supplierUser = res.data.data;
					} else {
						eltips(res.msg, "error");
					}
				});
			this.axios.get("/api/weishop/admin/category/list", {
				page: 1,
				limit: 100,
			}).then((resd) => {
				if (resd.code == 200) {
					_this.searchFrom.map((red, index) => {
						if (red.Field == 'category_id') {
							_this.searchFrom[index]["options"] = resd.data;
						}
					})
					// _this.searchFrom[2]["options"] = resd.data;
				} else {
					eltips(resd.msg, "error");
				}
			});
			this.goodsList()
		},
		methods: {
			// 搜索条件
			searchFun(e) {
				let _this = this;
				_this.goods.post.page = 1;
				_this.goods.post = {
					..._this.goods.post,
					...e
				};
				_this.goodsList();
			},
			saveFun() {
				let _this = this
				_this.axios.post("/api/weishop/admin/plugin/erp/procurement-task/store", this.orderInfo)
					.then((res) => {
						if (res.code == 200) {
							eltips(res.msg, "success");
							_this.toback()
						} else {
							eltips(res.msg, "error");
						}
					});
			},
			changeInput(scope,name){
				let sukList = this.orderInfo.detail
				let initVal = ''
				if(scope.index === 0){
					initVal = scope.row[name]
				}
				for (let i = 0; i < sukList.length; i++) {
					if(initVal){
						sukList[i][name] = initVal
					}
				}
			},
			changePage(e) {
				this.goods.post.page = e
				this.goodsList()
			},
			tableSelectionChange(e) {
				console.log(e)
				this.goods.list = e
			},
			goodsFun() {
				this.goods.show = false
				this.orderInfo.detail = this.mergeMissingItems(this.orderInfo.detail, this.goods.list)
			},
			goodsList() {
				let _this = this
				_this.axios.get("/api/weishop/admin/plugin/erp/goods/shop-index", {
						params: _this.goods.post
					})
					.then((res) => {
						if (res.code == 200) {
							if (res.data.data.length > 0) {
								res.data.data.map(red => {
									red.supplier_id = ''
									red.procurement_user_id = ''
									red.plan_number = ''
									red.remarks = ''
									return red
								})
							}
							this.goods.table = res.data.data;
							this.goods.total = res.data.total;
						} else {
							eltips(res.msg, "error");
						}
					});
			},
			mergeMissingItems(firstArray, secondArray) {
				// 构建第一组现有的联合键集合，用于快速查找
				const existingKeys = new Set();
				for (const item of firstArray) {
					const key = `${item.goods_id}|${item.goods_sku_id}`;
					existingKeys.add(key);
				}

				// 遍历第二组，将缺失的项补充到第一组
				for (const item of secondArray) {
					const key = `${item.goods_id}|${item.goods_sku_id}`;
					if (!existingKeys.has(key)) {
						firstArray.push(item);
						existingKeys.add(key); // 避免第二组自身重复插入
					}
				}

				return firstArray;
			},
			delFun(e) {
				this.orderInfo.detail.splice(e, 1)
			},
			toback() {
				this.$router.go(-1);
			},
			// 查询订单详情
			getDetail() {
				let _this = this;
				_this.axios
					.get("/api/weishop/admin/plugin/erp/procurement-order/detail/" + this.$route.query.id)
					.then((res) => {
						if (res.code == 200) {
							this.orderInfo = {
								plan_delivery_time: res.data.procurement_time,
								procurement_user_id: res.data.procurement_user_id,
								supplier_id: res.data.supplier_id,
								remarks: res.data.remarks,
								detail: res.data.detail
							}
						} else {
							eltips(res.msg, "error");
						}
					});
			},
		},
	};
</script>
<style lang="less" scoped>
	// 订单状态
	.status {
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 30px 0;

		.els {
			display: flex;
			justify-content: center;
			flex: 1;
			margin-left: 270px;
		}
	}

	// 订单详情
	.order-info {
		padding-top: 30px;

		&:first-child {
			padding-top: 0;
		}

		.btnbox {
			display: flex;
			align-items: center;
			padding-bottom: 20px;
			border-bottom: 1px solid #e8e8e8;
			margin-bottom: 20px;

			.btn {
				padding: 6px 15px;
				border: 1px solid #b8b8b8;
				margin-right: 10px;
			}
		}

		.info_itembox {
			display: flex;
			flex-wrap: wrap;
			align-items: center;

			.item {
				width: 25%;
				font-size: 14px;
				color: #000;
				margin-bottom: 10px;
			}

			&> :nth-last-child(-n + 4) {
				margin-bottom: 0;
			}
		}
	}

	.order_info_tit {
		font-size: 15px;
		font-weight: 600;
		margin-bottom: 15px;
		color: #000;
	}

	// 商品信息
	.goods_item {
		display: flex;
		align-items: center;

		.goods_img {
			img {
				width: 60px;
			}
		}

		.good_info {
			text-align: left;

			.info_name {
				display: -webkit-box;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 2;
				/* 显示 2 行 */
				overflow: hidden;
				text-overflow: ellipsis;
				/* 超出部分使用省略号表示 */
			}

			.info_sku {
				color: gray;
				font-size: 12px;

				.sku {
					display: inline-block;
				}
			}
		}
	}

	.totol {
		text-align: right;
		line-height: 30px;
		margin-right: 120px;
		margin-top: 20px;
		color: #000;

		span {
			font-weight: 600;
		}
	}

	/deep/.el-step__head.is-success {
		border-color: #006aff;
		color: #006aff;
	}

	/deep/.el-step__title.is-success {
		color: #006aff;
	}

	/deep/.el-step__description.is-success {
		color: #006aff;
	}
</style>